import { useAuth } from "../context/AuthContext";
import GoldSectionLayout from "../components/GoldSectionLayout";
import GoldSchedulePanel from "../components/GoldSchedulePanel";

export default function GoldSchedulePage() {
  const { token } = useAuth();
  return (
    <GoldSectionLayout
      title="7-Day Schedule"
      subtitle="Every upcoming fixture with ensemble top-3 market picks."
      testid="gold-schedule-page"
    >
      <GoldSchedulePanel token={token} />
    </GoldSectionLayout>
  );
}
